import mitt from 'mitt'
type BizEvents = {
  /**
   * 查看详情
   */
  VIEW_DETAIL: {
    pageName?: string | null
  }
  bar?: number
}
export const bizEvent = mitt<BizEvents>()
